import { Button, ListBox, ListBoxItem, Popover, Select, SelectValue } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import { values } from 'lodash';

import './TimeRangeFilter.scss';

type TimeRangeOption = {
  label: string;
  dateRange: [number, number];
};

type TimeRangeItem = {
  [key: string]: TimeRangeOption | undefined;
};

type TimeRangeFilterProps = {
  onSelect: ({ to, from }: { to: number; from: number }, label: string) => void;
  value: string;
  selectedOption?: string;
  timeRange: TimeRangeItem[];
  rightMarginSpacing?: boolean;
};

export function TimeRangeFilter({ onSelect, selectedOption, timeRange, rightMarginSpacing }: TimeRangeFilterProps) {
  const getOptions = () =>
    timeRange.map((sc: TimeRangeItem) => {
      const value = values(sc)[0] as TimeRangeOption;
      return {
        name: value.label,
        value: value.dateRange,
        id: value.label,
      };
    });

  const handleSelectionChange = (key: string | number | null) => {
    if (key) {
      const selectedTimeRange = getOptions().find(
        (option: { name: string; value: [number, number]; id: string }) => option.id === key,
      );
      if (selectedTimeRange) {
        const [startDate, endDate] = selectedTimeRange.value;
        onSelect({ to: endDate.valueOf(), from: startDate.valueOf() }, selectedTimeRange.name);
      }
    }
  };

  return (
    <div className={`time-range-filter ${rightMarginSpacing ? 'time-range-filter--margin-right' : ''}`}>
      <Select
        value={selectedOption}
        onChange={handleSelectionChange}
        className="time-range-filter__select"
        aria-label="Filter by time range"
      >
        <Button>
          <Icon name="clock" slot="start-icon" />
          <SelectValue />
          <Icon name="chevron-down" slot="end-icon" />
        </Button>
        <Popover>
          <ListBox>
            {getOptions().map((option: { name: string; value: [number, number]; id: string }) => (
              <ListBoxItem key={option.id} id={option.id} textValue={option.name}>
                {option.name}
              </ListBoxItem>
            ))}
          </ListBox>
        </Popover>
      </Select>
    </div>
  );
}
